
import Component from "vue-class-component";
import {Vue} from "vue-property-decorator";
import message from "@/assets/data/message/message.json";
import PageHero from "@/components/UI/renewal/PageHero.vue";
import CtaSection from "@/components/UI/renewal/CtaSection.vue";
import BrandButton from "@/components/UI/renewal/BrandButton.vue";

@Component({
  components: {PageHero, CtaSection, BrandButton}
})
export default class MessageContent extends Vue {
  // articleSectionItems: [0]=創業の経緯 / [1]=業界の課題 / [2]=信念
  private intro = message.articleSectionItems[0].contents;
  private pains = message.articleSectionItems[1].contents;
  private belief = message.articleSectionItems[2].contents;
  private presidentImageSrc = message.presidentImageSrc;
}
